/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Sparkle16 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g className="Sparkle 16">
      <path
        fill="#5E1FF0"
        d="M5.574 5.323c.12-.43.731-.43.852 0l.395 1.405A3.54 3.54 0 0 0 9.27 9.18l1.406.395c.43.12.43.731 0 .852l-1.405.394a3.54 3.54 0 0 0-2.451 2.452l-.395 1.405c-.12.43-.731.43-.852 0l-.395-1.405a3.54 3.54 0 0 0-2.45-2.452l-1.406-.394c-.43-.12-.43-.731 0-.852l1.405-.395A3.54 3.54 0 0 0 5.18 6.73l.395-1.406Z"
        className="Star 10"
      />
      <path
        fill="#5E1FF0"
        d="M11.744 1.194c.073-.259.44-.259.512 0l.236.843c.2.713.758 1.27 1.471 1.47l.843.237c.259.073.259.44 0 .512l-.843.236c-.713.2-1.27.758-1.47 1.471l-.237.843c-.073.259-.44.259-.512 0l-.236-.843a2.124 2.124 0 0 0-1.471-1.47l-.843-.237c-.259-.073-.259-.44 0-.512l.843-.236c.713-.2 1.27-.758 1.47-1.471l.237-.843Z"
        className="Star 12"
      />
    </g>
  </svg>
);
const Sparkle24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Sparkle 24">
      <path
        fill="#5E1FF0"
        d="M8.318 7.517c.194-.69 1.17-.69 1.364 0l.63 2.248a5.663 5.663 0 0 0 3.923 3.922l2.248.631c.69.194.69 1.17 0 1.364l-2.248.63a5.663 5.663 0 0 0-3.922 3.923l-.631 2.248c-.194.69-1.17.69-1.364 0l-.63-2.248a5.664 5.664 0 0 0-3.923-3.922l-2.248-.631c-.69-.194-.69-1.17 0-1.364l2.248-.63a5.663 5.663 0 0 0 3.922-3.923l.631-2.248Z"
        className="Star 10"
      />
      <path
        fill="#5E1FF0"
        d="M17.574 1.323c.12-.43.731-.43.852 0l.395 1.405a3.54 3.54 0 0 0 2.45 2.451l1.406.395c.43.12.43.731 0 .852l-1.405.395a3.54 3.54 0 0 0-2.451 2.45l-.395 1.406c-.12.43-.731.43-.852 0l-.395-1.405a3.54 3.54 0 0 0-2.45-2.451l-1.406-.395c-.43-.12-.43-.731 0-.852l1.405-.395a3.54 3.54 0 0 0 2.452-2.45l.394-1.406Z"
        className="Star 12"
      />
    </g>
  </svg>
);
const Sparkle32 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <g className="Sparkle 32">
      <path
        fill="#5E1FF0"
        d="M11.148 10.646c.242-.861 1.462-.861 1.704 0l.79 2.81a7.08 7.08 0 0 0 4.902 4.903l2.81.789c.861.242.861 1.462 0 1.704l-2.81.79a7.08 7.08 0 0 0-4.903 4.902l-.789 2.81c-.242.861-1.462.861-1.704 0l-.79-2.81a7.08 7.08 0 0 0-4.902-4.903l-2.81-.789c-.861-.242-.861-1.462 0-1.704l2.81-.79a7.08 7.08 0 0 0 4.903-4.902l.789-2.81Z"
        className="Star 10"
      />
      <path
        fill="#5E1FF0"
        d="M22.946 2.42c.157-.56.95-.56 1.108 0l.513 1.827a4.602 4.602 0 0 0 3.186 3.186l1.827.513c.56.157.56.95 0 1.108l-1.827.513a4.602 4.602 0 0 0-3.186 3.186l-.513 1.827c-.157.56-.95.56-1.108 0l-.513-1.827a4.602 4.602 0 0 0-3.186-3.186l-1.827-.513c-.56-.157-.56-.95 0-1.108l1.827-.513a4.602 4.602 0 0 0 3.186-3.186l.513-1.827Z"
        className="Star 12"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: Sparkle16,
  md: Sparkle24,
  lg: Sparkle32,
  xl: Sparkle32,
  xxl: Sparkle32,
  xxxl: Sparkle32,
};

export const SparkleIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'sparkle-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
